import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const StatusDone = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8917 6.44821C11.0989 6.17212 11.0431 5.78036 10.767 5.57318C10.4909 5.366 10.0991 5.42186 9.89194 5.69795L7.42467 8.98588L6.04188 7.65166C5.79348 7.41198 5.39781 7.41906 5.15814 7.66746C4.91846 7.91586 4.92554 8.31153 5.17394 8.5512L6.90298 10.2195C7.25995 10.5639 7.83797 10.5177 8.13569 10.121L10.8917 6.44821Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM12.75 8C12.75 10.6234 10.6234 12.75 8 12.75C5.37665 12.75 3.25 10.6234 3.25 8C3.25 5.37665 5.37665 3.25 8 3.25C10.6234 3.25 12.75 5.37665 12.75 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default StatusDone;
